import { EventsFlowActionNodeTypes } from '../../models/events-flow-action-node-types';
import { EventsFlowEventNodeTypes } from '../../models/events-flow-event-node-types';

export const EVENT_DATA_EXAMPLES = {
  [EventsFlowEventNodeTypes.OnNewCallIncoming]: {
    callFrom: 'John Doe',
    callFromAni: '+12345678950',
    callFromFull: '"John Doe" <sip:+12345678950@test.test.com>',
    callId: '73c4bfc63c767003c0dd1f@0.0.0.0:5000',
    callTo: 'Call Queue Test',
    callToAni: '+12345678960',
    callToFull: '"Call Queue" <sip:+12345678960@test.test.com>',
    callType: 'newcall',
    domain: 'test.test.com',
    provider: 'provider',
  },
  [EventsFlowEventNodeTypes.OnRecordingAvailable]: {
    domain: '42850.tgpbx.com',
    provider: 'vodia',
    cdrStartDate: '2025-01-24T12:11:51.433Z',
    customerId: '1611',
    duration: 12,
    fileName:
      'cp_media/development/recordings/42850.tgpbx.com/204/20250124_9294240240_071139_204_ReplaceMyDuration_i_+.wav',
    fileSize: 19236,
  },
  [EventsFlowEventNodeTypes.OnConnectToAgent]: {
    callFrom: 'John Doe',
    callFromAni: '+12345678950',
    callFromFull: '"John Doe" <sip:+12345678950@test.test.com>',
    callId: '73c4bfc62c767003c0dd1f@0.0.0.0:5000',
    callTo: 'Call Queue Test',
    callToAni: '+12345678960',
    callToFull: '"Call Queue" <sip:+12345678960@test.test.com>',
    callType: 'newcall',
    domain: 'test.test.com',
    extension: 'extension',
    provider: 'provider',
  },
  [EventsFlowEventNodeTypes.OnCallDetailRecord]: {
    answeredBy: ['1003'],
    answeredByH: '1003',
    callId: '251303602d24eded0fd6081946481d27@54.241.2.236:5060',
    callRecId: '214286',
    callStatus: 'Answered',
    callType: 'Incoming',
    domain: 'test.domain.com',
    durationHold: 0,
    durationHoldFormatted: '00:00:00',
    durationIvr: 10893,
    durationIvrFormatted: '00:00:11',
    durationRing: 4971,
    durationRingFormatted: '00:00:05',
    durationTalk: 9219,
    durationTalkFormatted: '00:00:09',
    durationTotal: 25083,
    durationTotalFormatted: '00:00:25',
    fromFull: '1234561450 - John Doe',
    fromName: 'John Doe',
    fromNumber: '+1234561450',
    hasRecordings: true,
    humanizedStates: [
      {
        details: 'Incoming call to (332) 222-4444 from (234) 561-1450 – John Doe',
        duration: 0,
        eventName: 'Incoming',
        eventTitle: 'Incoming',
        time: '2024-10-31T14:44:11.199Z',
      },
      {
        details: 'Routed to Agent Group 3300 – Call Queue Test',
        duration: 0,
        eventName: 'Call Progress',
        eventTitle: 'Routing',
        time: '2024-10-31T14:44:11.199Z',
      },
      {
        details:
          'Rang to Ext: 1003 – Richard Roe [Redirect: (332) 222-4444 – Call Queue Test]  (SoftPhone/3.5.5 Desktop (X11; Linux x86_64))',
        duration: 4971,
        eventName: 'Call Progress',
        eventTitle: 'Ring',
        time: '2024-10-31T14:44:22.112Z',
      },
      {
        details: 'Picked up by 1003 – Richard Roe  (SoftPhone/3.5.5 Desktop (X11; Linux x86_64))',
        duration: 0,
        eventName: 'Call Progress',
        eventTitle: 'Pick Up',
        time: '2024-10-31T14:44:27.053Z',
      },
      {
        details:
          '(234) 561-1450 – John Doe talked to 1003 – Richard Roe  (SoftPhone/3.5.5 Desktop (X11; Linux x86_64))',
        duration: 9219,
        eventName: 'Call Progress',
        eventTitle: 'Talk',
        time: '2024-10-31T14:44:27.063Z',
      },
      {
        details: 'End of call',
        duration: 0,
        eventName: 'Hang up',
        eventTitle: 'Hang up',
        time: '2024-10-31T14:44:36.384Z',
      },
    ],
    id: '214276',
    ip: '',
    isGroup: true,
    isIncoming: true,
    isLocal: false,
    isMailbox: false,
    isMissed: false,
    isOutgoing: false,
    missedBy: [],
    missedByH: '',
    mongoDbId: 'webcdr_672397d50010a47ff4e469ef',
    reasonH: '',
    recordings: [
      {
        account: '3300',
        accountName: 'Call Queue Test',
        extension: '1003',
        extensionName: 'Richard Roe',
        file: 'recordings/test.domain.com/3300/20241031_8459991450_104427_3300_ReplaceMyDuration_i_44c39596-1109-47c1-9e90-eb9ce9cdcc01+ab389cda-b000-4aed-9cda-d066039db9b1.wav',
        id: '163114',
        recId: '72783',
        time: '2024-10-31T14:44:11.199Z',
      },
    ],
    start: '2024-10-31T14:44:11.199Z',
    statusBy: '1003',
    surveyResults: [],
    toFull: '3322224444 - Call Queue Test',
    toName: 'Call Queue Test',
    toNumber: '+133222224444',
  },

  [EventsFlowActionNodeTypes.TranscribeCallRecording]: {
    confidence: 0.98165566,
    duration: 30.719938,
    sentimentInfo: { inputTokens: 70, outputTokens: 70, score: -0.8022321428571428, sentiment: 'negative' },
    summaryInfo: { summary: 'Transcript summary', inputTokens: 30, outputTokens: 30 },
    transcript: 'Transcript',
  },
};
